import { ArrowLeft, ArrowRight } from "lucide-react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import image1 from "../../assets/promo1.png";
import image2 from "../../assets/promo2.png";
import image3 from "../../assets/promo3.png";
import PromoCard from "../PromoCard/PromoCard";
import "./PromoCardParent.css";

const data = [
  {
    bannerTitle: "0Tk Delivery Fee + up to 50%",
    bannerButtonLabel: "Try free for 4 weeks",
    bannerImage: image1,
    bannerBackgroundColor: "#ffd400",
    bannerButtonURL: "/",
  },
  {
    bannerTitle: "Free Coffee on First Order!",
    bannerButtonLabel: "Claim Now",
    bannerImage: image2,
    bannerBackgroundColor: "#4caf50",
    bannerButtonURL: "/",
  },
  {
    bannerTitle: "Buy 1 Get 1 Free Pizza!",
    bannerButtonLabel: "Grab Offer",
    bannerImage: image3,
    bannerBackgroundColor: "#00d499",
    bannerButtonURL: "/",
  },
  {
    bannerTitle: "0Tk Delivery Fee + up to 50%",
    bannerButtonLabel: "Try free for 4 weeks",
    bannerImage: image1,
    bannerBackgroundColor: "#ff5722",
    bannerButtonURL: "/",
  },
  {
    bannerTitle: "Free Coffee on First Order!",
    bannerButtonLabel: "Claim Now",
    bannerImage: image2,
    bannerBackgroundColor: "#4caf50",
    bannerButtonURL: "/",
  },
  {
    bannerTitle: "Buy 1 Get 1 Free Pizza!",
    bannerButtonLabel: "Grab Offer",
    bannerImage: image3,
    bannerBackgroundColor: "#ee0000",
    bannerButtonURL: "/",
  },
];

const PromoCardParent = () => {
  const breakpoints = {
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    576: {
      slidesPerView: 1.3,
      spaceBetween: 12,
    },
  };

  return (
    <div className="home-content-shell position-relative my-3 ">
      <div className="promo-card-parent position-relative">
        <div className="px-3">
          <Swiper
            modules={[Navigation]}
            navigation={{
              nextEl: ".slick-next",
              prevEl: ".slick-prev",
            }}
            slidesPerView={1.3}
            spaceBetween={12}
            loop={data.length > 5}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            speed={500}
            breakpoints={breakpoints}
          >
            {data?.map((item, index) => (
              <SwiperSlide>
                <PromoCard key={index} data={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="">
          <div className="custom-arrow slick-prev d-flex justify-content-center align-items-center">
            <ArrowLeft />
          </div>
          <div className="custom-arrow slick-next d-flex justify-content-center align-items-center">
            <ArrowRight />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoCardParent;
